<template>
    <component :is="Component" :class="Class">
        <slot></slot>
    </component>
</template>

<script lang="ts">
import { Options } from 'vue-class-component';
import {Vue} from 'vue-class-component';

@Options({
    name:'NextButton',
    components:{

    },
    props:{
        variant:{
            type:String,
            default: 'primary'
        },
        component:{
            type:String,
            default: 'button'
        }
    }
})

export default class NextButton extends Vue {
    variant!: string
    component!: string

    get Component(){
        if(this.$attrs['disabled']){
            return 'button'
        }
        return this.component
    }

    get Class(){
        switch (this.variant){
            case 'primary':
                return 'bg-next-orange border-2 border-next-orange text-center text-white hover:bg-next-dark-gray hover:border-next-dark-gray focus:ring focus:ring-next-orange-ring focus:bg-next-orange focus:border-next-orange focus:text-white active:shadow active:border-white active:bg-white active:text-next-orange disabled:bg-next-gray-md-dark disabled:border-next-gray-md-dark disabled:text-next-dark-gray-disabled'
            case 'secondary':
                return 'border-2 border-next-dark-gray text-center bg-next-dark-gray text-white hover:bg-next-atp hover:border-next-atp active:border-white active:bg-white active:text-next-dark-gray active:shadow focus:text-white focus:bg-next-dark-gray focus:ring focus:ring-next-dark-gray-ring disabled:bg-next-gray-md-dark disabled:border-next-gray-md-dark disabled:text-next-dark-gray-disabled'
            case 'outline-primary':
                return 'border-2 border-next-orange text-center text-next-orange hover:bg-next-orange hover:border-next-dark-gray hover:text-white focus:ring focus:ring-next-orange-ring focus:bg-next-orange focus:text-white active:shadow active:border-white active:bg-white active:text-next-orange disabled:bg-white disabled:border-next-dark-gray-disabled disabled:text-next-dark-gray-disabled'
            case 'outline-secondary':
                return 'border-2 border-next-dark-gray text-center text-next-dark-gray hover:bg-next-atp hover:border-next-atp hover:text-white active:border-white active:bg-white active:text-next-dark-gray active:shadow focus:text-white focus:bg-next-dark-gray focus:ring focus:ring-next-dark-gray-ring disabled:bg-white disabled:border-next-dark-gray-disabled disabled:text-next-dark-gray-disabled'
        }
        return ''
    }
}
</script>
